import { Component, computed, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UiModule } from '../../../components/ui.module';

@Component({
  selector: 'app-discussion-thread-comment-adder',
  imports: [UiModule, FormsModule],
  templateUrl: './discussion-thread-comment-adder.component.html',
  styleUrl: './discussion-thread-comment-adder.component.scss',
})
export class DiscussionThreadCommentAdderComponent {
  public comment = model<string>('');
  public addComment = output<string>();

  public canSubmitComment = computed(() => this.comment().trim().length > 0);

  public submitComment() {
    if (!this.canSubmitComment()) return;

    this.addComment.emit(this.comment().trim());
    this.comment.set('');
  }
}
